export default __webpack_public_path__ + "static/media/sm-arrow-right.ad3a851b.svg";